// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"203ca0c3","796":"1c615ce6"}[chunkId] + ".chunk.js";
};